/* ============================================================
 * Casa M Spice Co — Recipes Hub enhancements
 * Added 2026-06-03 (Bloom audit follow-up).
 *   1. Ingredient scaler (½×/1×/2×/3×)
 *   2. US <-> Metric unit toggle (volume / weight / temp)
 *   3. Sticky filter/search bar anchoring under the site header
 *   4. Share button (native share / copy link)
 * Progressive enhancement: if JS is off, the page renders normally
 * (scale/unit controls stay hidden, ingredients show as authored).
 * ============================================================ */
(function () {
  'use strict';

  /* ---------- quantity parsing + formatting ---------- */
  var UNI = { '¼':0.25,'½':0.5,'¾':0.75,'⅐':1/7,'⅑':1/9,'⅓':1/3,'⅔':2/3,'⅛':0.125,'⅜':0.375,'⅝':0.625,'⅞':0.875,'⅕':0.2,'⅖':0.4,'⅗':0.6,'⅘':0.8 };
  function tokenToNum(tok) {
    if (tok == null) return null;
    tok = String(tok).trim();
    if (tok === '') return null;
    if (UNI[tok] != null) return UNI[tok];
    // "1 1/2" or "1½"
    var m = tok.match(/^(\d+)\s*([¼½¾⅓⅔⅛⅜⅝⅞⅕⅖⅗⅘⅐⅑])$/);
    if (m) return parseInt(m[1], 10) + UNI[m[2]];
    m = tok.match(/^(\d+)\s+(\d+)\/(\d+)$/); // mixed "1 1/2"
    if (m) return parseInt(m[1],10) + parseInt(m[2],10)/parseInt(m[3],10);
    m = tok.match(/^(\d+)\/(\d+)$/); // "1/2"
    if (m) return parseInt(m[1],10)/parseInt(m[2],10);
    if (/^\d+(\.\d+)?$/.test(tok)) return parseFloat(tok);
    return null;
  }
  var COMMON = [[1/8,'⅛'],[1/4,'¼'],[1/3,'⅓'],[3/8,'⅜'],[1/2,'½'],[5/8,'⅝'],[2/3,'⅔'],[3/4,'¾'],[7/8,'⅞']];
  function numToStr(n) {
    if (n == null || isNaN(n)) return null;
    if (n === 0) return '0';
    var whole = Math.floor(n + 1e-9), frac = n - whole, best = null, bd = 1;
    for (var i=0;i<COMMON.length;i++){ var d=Math.abs(frac-COMMON[i][0]); if(d<bd){bd=d;best=COMMON[i];} }
    if (frac < 0.05) return String(whole);
    if (best && bd < 0.06) return (whole>0 ? whole+' ' : '') + best[1];
    var r = Math.round(n*100)/100;
    return (Math.round(r) === r) ? String(r) : String(parseFloat(r.toFixed(2)));
  }

  /* ---------- unit conversion (US -> metric) ---------- */
  // returns {qty, unit} or null if unit not recognized
  function toMetric(qty, unit) {
    var u = unit.toLowerCase().replace(/\.$/,'');
    var ml=null, g=null;
    if (/^(cups?|c)$/.test(u)) ml = qty*236.588;
    else if (/^(tablespoons?|tbsps?|tbsp|tbs|tb)$/.test(u)) ml = qty*14.787;
    else if (/^(teaspoons?|tsps?|tsp)$/.test(u)) ml = qty*4.929;
    else if (/^(fl|fluid)$/.test(u)) return null; // "fl oz" handled by caller join; skip
    else if (/^(pints?|pt)$/.test(u)) ml = qty*473.176;
    else if (/^(quarts?|qt)$/.test(u)) ml = qty*946.353;
    else if (/^(gallons?|gal)$/.test(u)) ml = qty*3785.41;
    else if (/^(ounces?|oz)$/.test(u)) g = qty*28.3495;
    else if (/^(pounds?|lbs?|lb)$/.test(u)) g = qty*453.592;
    else return null;
    if (ml != null) {
      if (ml >= 1000) return { qty: Math.round(ml/100)/10, unit: 'L' };
      return { qty: Math.round(ml), unit: 'ml' };
    }
    if (g != null) {
      if (g >= 1000) return { qty: Math.round(g/10)/100, unit: 'kg' };
      return { qty: Math.round(g), unit: 'g' };
    }
    return null;
  }

  // Leading-quantity matcher — built from parts to keep escaping bulletproof.
  var FR = '[¼½¾⅓⅔⅛⅜⅝⅞⅕⅖⅗⅘⅐⅑]';
  var NUM = '(?:\\d+\\s*' + FR + '|\\d+\\s+\\d+\\/\\d+|\\d+\\/\\d+|' + FR + '|\\d+(?:\\.\\d+)?)';
  var UNITS = '(?:fl\\s*oz|fluid\\s+ounces?|tablespoons?|tbsps?|tbsp|tbs|teaspoons?|tsps?|tsp|cups?|pints?|pt|quarts?|qt|gallons?|gal|ounces?|oz|pounds?|lbs?|lb|c)';
  var QTY = new RegExp('^(\\s*)(' + NUM + ')(?:\\s*(?:-|–|—|to)\\s*(' + NUM + '))?(?:\\s*(' + UNITS + ')\\b)?', 'i');

  function transformLine(base, scale, metric) {
    var m = base.match(QTY);
    if (!m) return base;
    var lead = m[1] || '';
    var n1 = tokenToNum(m[2]);
    if (n1 == null) return base;
    var rest = base.slice(m[0].length);
    var unitRaw = (m[4] || '').trim();
    // scale
    var s1 = n1 * scale;
    var n2 = m[3] != null ? tokenToNum(m[3]) : null;
    var s2 = n2 != null ? n2 * scale : null;
    var out;
    if (metric && unitRaw) {
      var c1 = toMetric(s1, unitRaw);
      if (c1) {
        out = String(c1.qty);
        if (s2 != null) { var c2 = toMetric(s2, unitRaw); if (c2) out += '–' + c2.qty; }
        out += ' ' + c1.unit;
        return lead + out + rest;
      }
    }
    // US (or unconvertible): keep unit, scaled number
    out = numToStr(s1);
    if (s2 != null) out += '–' + numToStr(s2);
    if (unitRaw) out += ' ' + unitRaw;
    return lead + out + rest;
  }

  function initScaler() {
    var root = document.querySelector('[data-ing-root]');
    var bar = document.querySelector('[data-rscale]');
    if (!root || !bar) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('.d2-ing__item'));
    items.forEach(function (li) { li.dataset.base = li.textContent.trim(); });
    var state = { scale: 1, metric: false };
    function apply() {
      items.forEach(function (li) {
        var t = transformLine(li.dataset.base, state.scale, state.metric);
        li.textContent = t;
        li.classList.toggle('is-scaled', state.scale !== 1 || state.metric);
      });
      applyMethodTemps(state.metric);
    }
    bar.removeAttribute('hidden');
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('.d2-rscale__btn'); if (!b) return;
      if (b.dataset.scale != null) {
        state.scale = parseFloat(b.dataset.scale);
        setActive(b, '[data-scale]');
      } else if (b.dataset.units != null) {
        state.metric = b.dataset.units === 'metric';
        setActive(b, '[data-units]');
      }
      apply();
    });
    function setActive(btn, sel) {
      bar.querySelectorAll(sel).forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed','false'); });
      btn.classList.add('is-active'); btn.setAttribute('aria-pressed','true');
    }
  }

  // Annotate °F with approx °C in method steps when metric is on
  function applyMethodTemps(metric) {
    var ps = document.querySelectorAll('.d2-method p, .d2-tip p');
    ps.forEach(function (p) {
      if (p.dataset.baseTemp == null) p.dataset.baseTemp = p.innerHTML;
      if (!metric) { p.innerHTML = p.dataset.baseTemp; return; }
      p.innerHTML = p.dataset.baseTemp.replace(/(\d{2,3})\s*°?\s*F\b/g, function (full, f) {
        var c = Math.round((parseInt(f,10) - 32) * 5/9);
        return full + ' (' + c + '°C)';
      });
    });
  }

  /* ---------- sticky filter bar anchoring ---------- */
  function initSticky() {
    var filter = document.querySelector('.d2-filter');
    if (!filter) return;
    var header = document.querySelector('.header-sticky-wrapper') || document.querySelector('.site-header');
    function setTop() {
      var h = 0;
      if (header) {
        var cs = getComputedStyle(header);
        if (cs.position === 'sticky' || cs.position === 'fixed') h = header.offsetHeight;
      }
      document.documentElement.style.setProperty('--cs-stick-top', h + 'px');
    }
    setTop();
    window.addEventListener('resize', setTop, { passive: true });
    var sentinel = document.createElement('div');
    filter.parentNode.insertBefore(sentinel, filter);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        filter.classList.toggle('is-stuck', es[0].intersectionRatio < 1);
      }, { threshold: [1] }).observe(sentinel);
    }
  }

  /* ---------- share ---------- */
  function initShare() {
    document.querySelectorAll('[data-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var data = { title: document.title, url: location.href };
        if (navigator.share) { navigator.share(data).catch(function(){}); }
        else if (navigator.clipboard) {
          navigator.clipboard.writeText(location.href).then(function () {
            var t = btn.textContent; btn.textContent = '✓ Link copied';
            setTimeout(function () { btn.textContent = t; }, 1800);
          });
        }
      });
    });
  }

  function boot() { try { initScaler(); } catch(e){} try { initSticky(); } catch(e){} try { initShare(); } catch(e){} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
